import { Injectable } from '@angular/core';
import { FeedSelectorConfiguration } from './models/feed-selector-configuration.model';
declare var feedSelectorConfig: FeedSelectorConfiguration[];

@Injectable()
export class FeedSelectorConfigurationService {
    public configuration: FeedSelectorConfiguration[];

    constructor() {
      // selector's feed id field name (primary key)
      // selector's feed display field name
      this.configuration = JSON.parse('[{"selectorType": "selectorpnode","feedKey": "pnode","sourceIdentityField": "pnode_id", "sourceDisplayField": "pnode_name" }]');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-selector-configuration.service.ts